export const API_ENDPOINTS = {
  GET_ORDER: 'order/get',
  CHANGE_ORDER_POSITION: 'order/change-order-position',
  // PAY_ORDER: '/best2pay/payorder/',
  PAY_ORDER: '/payment/payorder/',
  CHECK_TRANSACTION: <T>(id: T) => `/payment/transaction-status/${id}`,
  CHECK_DIVIDE_BILL: (id: number) => `/shop/${id}/diff-pay`
}
